@if (learnizParams?.styleParams?.fontTitle?.src) {
  <shared-fonts-loader [font]="learnizParams.styleParams.fontTitle"></shared-fonts-loader>
}

@if (isPreview && backofficeUrl$ | async; as url) {
  <div class="link-preview">
    <a [href]="getBackofficeUrl(url)">
      <i aria-hidden="true" class="icon-learniz-edit"></i>
      <span>{{ 'preview.backoffice-back' | wording }}</span>
    </a>
    <a [href]="goBackCreations(url)">
      <i aria-hidden="true" class="icon-learniz-spinner11"></i>
      <span>{{ 'preview.backoffice-creation' | wording }}</span>
    </a>
  </div>
}
<div id="learniz-layout" [class.preview-mode]="isPreview && backofficeUrl$ | async">
  <router-outlet (activate)="loadComponent($event)"></router-outlet>
</div>

<shared-toggle-read-speaker-visibility></shared-toggle-read-speaker-visibility>
